import React, {Fragment, useEffect, useRef, useState} from "react";
import websocketAddress from "../_sig_api/_websocketAdress";
import {s_char} from "../_signals/s_char";
import {websocketSubscriber} from "../_helper/websocketBehave";
import {isEmpty} from "../_helper/isEmpty";
import CharName from "../CharHeader/CharName";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MobileFriendlyIcon from "@mui/icons-material/MobileFriendly";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import ComputerIcon from "@mui/icons-material/Computer";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import {useSignals} from "@preact/signals-react/runtime";
import {IlsUser} from "../_interfaces/IlsUser";
import {IniMessage} from "../_messages/IniMessage";
import {s_ini} from "../_signals/s_ini";
import {ResultsClearMessage} from "../_messages/ResultsClearMessage";
import {ResultsAddMessage} from "../_messages/ResultsAddMessage";
import {IniClearMessage} from "../_messages/IniClearMessage";
import Char from "../Char/Char";
import Chars from "../Chars/Chars";
import CharNSC from "../Char/CharNSC";
import {IniAddMessage} from "../_messages/IniAddMessage";
import {IniUnSetCurrentMessage} from "../_messages/IniUnSetCurrentMessage";
import {IniSetNextMessage} from "../_messages/IniSetNextMessage";
import {IniSetCurrentMessage} from "../_messages/IniSetCurrentMessage";
import {IniSetWaitMessage} from "../_messages/IniSetWaitMessage";
import {OnOpenMessage} from "../_messages/OnOpenMessage";
import {CharacterFieldsUpdateMessage} from "../_messages/CharacterFieldsUpdateMessage";
import {CharacterNotesAddMessage} from "../_messages/CharacterNotesAddMessage";
import {CharacterNotesUpdateMessage} from "../_messages/CharacterNotesUpdateMessage";
import {CharacterTalentsAddMessage} from "../_messages/CharacterTalentsAddMessage";
import {CharacterTalentsUpdateMessage} from "../_messages/CharacterTalentsUpdateMessage";
import {CharacterSkillsAddMessage} from "../_messages/CharacterSkillsAddMessage";
import {CharacterSkillsUpdateMessage} from "../_messages/CharacterSkillsUpdateMessage";
import {CharacterModsAddMessage} from "../_messages/CharacterModsAddMessage";
import {CharacterModsUpdateMessage} from "../_messages/CharacterModsUpdateMessage";
import wsUpdates from "./wsUpdates";
import {Snackbar} from "@mui/material";
import DialogRoller from "../dialogRoller/dialogRoller";
import Initiative from "../Initiative/Initiative";
import RolledList from "../RolledList/RolledList";
import {msgTypeIni, msgTypeOnOpen} from "../_messages/MessageTypes";
import {
    s_app_mobile, s_app_mobile_tab,
    s_app_sl,
    s_app_toggleMobile
} from "../_signals/s_app";
import Disciplines from "../Char/Disciplines/Disciplines";
import Talents from "../Char/Talents/Talents";
import TalentSkillPopover from "../PopoverTalentSkill/TalentSkillPopover";
import LP from "../Char/Sonstiges/LP";
import Notes from "../Char/Sonstiges/Notes";
import Coins from "../Char/Sonstiges/Coins";
import Diary from "../Char/Sonstiges/Diary";
import Skills from "../Char/Skills/Skills";
import Weapons from "../Char/Weapons/Weapons";
import Armor from "../Char/Armor/Armor";
import MatriceSpell from "../Char/MatriceSpell/MatriceSpell";
import SpellPopover from "../PopoverSpell/SpellPopover";
import Threads from "../Char/Threads/Threads";
import BloodMagicItems from "../Char/BloodMagicItems/BloodMagicItems";
import Presets from "../Char/Roll/Presets";
import BloodMagicItemPopover from "../PopoverBloodMagicItem/BloodMagicItemPopover";
import DisciplinePopover from "../PopoverDiscipline/DisciplinePopover";
import {logout} from "../_helper/logout";
import Roll from "../Char/Roll/Roll";
import Stack from "@mui/material/Stack";

interface MsgBase {
    type: string
}

export type WebSocketMessage =
    MsgBase
    | OnOpenMessage
    | IniMessage
    | IniAddMessage
    | IniClearMessage
    | IniSetWaitMessage
    | IniSetCurrentMessage
    | IniSetNextMessage
    | IniUnSetCurrentMessage
    | ResultsAddMessage
    | ResultsClearMessage
    | CharacterFieldsUpdateMessage
    | CharacterNotesAddMessage
    | CharacterNotesUpdateMessage
    | CharacterTalentsAddMessage
    | CharacterTalentsUpdateMessage
    | CharacterSkillsAddMessage
    | CharacterSkillsUpdateMessage
    | CharacterModsAddMessage
    | CharacterModsUpdateMessage;


function Main() {
    useSignals()

    const [tab, setTab] = useState('char');
    const [hasIni, setHasIni] = useState(false);
    const [newRound, setNewRound] = useState(false);

    const [wsconnected, setWsConnected] = useState(false);
    const wssocket = useRef<WebSocket | null>(null);
    const wsHeartbeatInterval = useRef<NodeJS.Timeout | null>(null);
    const wsReconnectTimeout = useRef<NodeJS.Timeout | null>(null);
    const wsReconnectAttempts = useRef(0);
    const wsPongTimeout = useRef<NodeJS.Timeout | null>(null);

    const menu = [
        {k: 'char', v: 'Charakter'},
        {k: 'roll', v: 'Würfeln'},
        {k: 'ini', v: 'Initiative'},
        {k: 'skills', v: 'Fertigkeiten'},
        {k: 'disciplines', v: 'Disziplinen'},
        {k: 'talents', v: 'Talente'},
        {k: 'weapons', v: 'Waffen'},
        {k: 'armor', v: 'Rüstung'},
        {k: 'matrixspell', v: 'Zaubern'},
        {k: 'threads', v: 'Fäden'},
        {k: 'other', v: 'LP & Münzen'},
        {k: 'diarynotes', v: 'Tagebuch/Notizen'},
        {k: 'bloodmagic', v: 'Blutmagie'},
    ]


    useEffect(() => {

        wsConnect();

        websocketSubscriber.subscribe((msg) => {
            if (!isEmpty(msg)) {
                if (wssocket.current) wssocket.current.send(JSON.stringify(msg));
            }
        });

        return () => {
            wsdisconnect();
        };
    }, []);

    const handleNewRoundClose = () => {
        setNewRound(false);
    }

    const wsdisconnect = () => {

        if (wssocket.current) {
            wssocket.current.close();
        }
        wsStopHeartbeat();
        if (wsReconnectTimeout.current) clearTimeout(wsReconnectTimeout.current);
    }

    const wsStartHeartbeat = () => {
        wsHeartbeatInterval.current = setInterval(() => {
            if (wssocket.current && wssocket.current.readyState === WebSocket.OPEN) {
                wssocket.current.send(JSON.stringify({type: 'ping'}));
                wsResetHeartbeat();
                wsPongTimeout.current = setTimeout(() => {
                    console.error('Pong-Timeout: Verbindung wird wiederhergestellt.');
                    wsdisconnect();
                    wsConnect();
                }, 10000);
            }
        }, 30000);
    };

    const wsStopHeartbeat = () => {
        if (wsHeartbeatInterval.current) clearInterval(wsHeartbeatInterval.current);
        if (wsPongTimeout.current) {
            clearTimeout(wsPongTimeout.current);
        }
    };

    const wsResetHeartbeat = () => {
        if (wsPongTimeout.current) {
            clearTimeout(wsPongTimeout.current);
        }
    };

    const wsScheduleReconnect = () => {
        const delay = Math.min(wsReconnectAttempts.current * 2000, 30000);
        wsReconnectTimeout.current = setTimeout(() => {
            wsConnect();
            wsReconnectAttempts.current++;
        }, delay);
    };

    const wsConnect = () => {
        wssocket.current = new WebSocket(websocketAddress);

        const user = localStorage.getItem('user');
        const char = localStorage.getItem('char');
        const round = localStorage.getItem('round');

        wssocket.current.onopen = () => {
            console.log('wssocket.onopen')
            setWsConnected(true);
            wsStartHeartbeat();
            wsReconnectAttempts.current = 0;
            console.log('WebSocket-Verbindung hergestellt');

            if (user && char && round) {
                const userData: IlsUser = JSON.parse(user);

                const onopen: OnOpenMessage = {
                    type: msgTypeOnOpen,
                    uid: userData.id,
                    cid: s_char.value.id,
                    rid: round
                }
                if (wssocket.current) wssocket.current.send(JSON.stringify(onopen))
            }
        };

        wssocket.current.onclose = () => {
            setWsConnected(false);
            wsStopHeartbeat();
            wsScheduleReconnect();
            console.log('WebSocket-Verbindung geschlossen');
        };

        wssocket.current.onerror = () => {
            setWsConnected(false);
            wsStopHeartbeat();
            wsScheduleReconnect();
            console.error('WebSocket-Fehler');
        };

        if (wssocket.current) wssocket.current.onmessage = (message: any) => {
            // console.log(message)
            let data: MsgBase = {
                type: ''
            };
            try {
                data = JSON.parse(message.data) as WebSocketMessage;
                if (!data.hasOwnProperty('type')) data.type = 'none'
            } catch (e) {
                console.log(e)
                return;
            }

            if (data.type === 'pong') {
                wsResetHeartbeat();
            } else {
                console.log('NO PONG', data)
                if (data.hasOwnProperty('type') && data.type === msgTypeIni) {
                    const msg = (data as IniMessage);
                    setNewRound(msg.payload.newRound)
                    const me = msg.payload.ini.findIndex(ini => ini.current && ini.cid === s_char.value.id);
                    setHasIni(me >= 0)
                    s_ini.value = msg.payload.ini;
                } else wsUpdates(data);
            }
        }
    };


    const showSLTab = (show: string) => {
        return s_app_sl.value && (!s_app_mobile.value || (s_app_mobile.value && tab === show));
    }

    const showTab = (show: string) => {
        return (!s_app_mobile.value || (s_app_mobile.value && tab === show));
    }

    return <Fragment>
        <DialogRoller/>
        <TalentSkillPopover/>
        <SpellPopover/>
        <BloodMagicItemPopover/>
        <DisciplinePopover/>
        <Snackbar
            open={newRound}
            autoHideDuration={600}
            message="Neue Runde"
            onClose={handleNewRoundClose}
        />

        <div style={{
            backgroundColor: wsconnected ? 'green' : 'red',
            padding: 0,
            bottom: '-15px',
            left: '-15px',
            zIndex: 10000,
            rotate: '45deg',
            height: '30px',
            width: '30px',
            position: 'fixed'
        }}>&nbsp;</div>

        {hasIni ? <div
            style={{
                position: 'fixed',
                top: -18,
                right: -18,
                marginRight: -8,
                backgroundColor: 'rgba(45, 174, 45, 0.8)',
                width: 90,
                height: 40,
                rotate: '45deg'
            }}>
        </div> : null}
        <div className={'header'}>
            <CharName></CharName>
        </div>
        <div className={'main'}>
            {!s_char.value.nsc && showTab('char') ? <Char/> : null}
            {s_char.value.nsc && showTab('char') ? <CharNSC/> : null}

            {showSLTab('char') ? <Fragment>
                <Chars nsc={true}/>
                <Chars nsc={false}/>
            </Fragment> : null}

            {s_app_mobile.value && tab === 'roll' ? <Fragment>
                <Roll/>
                <RolledList/>
            </Fragment> : null}

            {s_app_mobile.value && tab === 'ini' ? <Initiative/> : null}

            {!s_app_mobile.value ? <Fragment>
                <Presets/>

                <Grid container columnSpacing={{xs: 1}}>
                    <Grid item xs={12}>
                        <Initiative></Initiative>
                    </Grid>
                </Grid>
                <RolledList/>
            </Fragment> : null}

            {showTab('disciplines') ? <Disciplines/> : null}

            {showTab('talents') ? <Talents roll={false}/> : null}

            {showTab('other') ? <Fragment>
                <LP/>
                <Coins/>
            </Fragment> : null}

            {showTab('diarynotes') ? <Fragment>
                <Diary/>
                <Notes/>
            </Fragment> : null}

            {showTab('skills') ? <Skills roll={false}/> : null}

            {showTab('weapons') ? <Weapons/> : null}

            {showTab('armor') ? <Armor/> : null}

            {showTab('matrixspell') ? <MatriceSpell roll={false}/> : null}

            {showTab('threads') ? <Threads/> : null}

            {showTab('bloodmagic') ? <Fragment>
                <BloodMagicItems/>
            </Fragment> : null}

        </div>

        <div className={'footer'}>

            {!s_app_mobile.value ?
                <Paper style={{height: '100%'}}>
                    <IconButton style={{float: 'left'}} onClick={() => {
                        s_app_toggleMobile()
                    }}><MobileFriendlyIcon/>
                    </IconButton>
                    <span className="text-muted">&copy; 2025</span>
                    <span className="text-muted">Build: 4.0</span>
                    <Button style={{float: 'right'}} onClick={() => logout()}>logout</Button>
                </Paper>
                :

                <Paper style={{height: '100%'}}>
                    <Select style={{width: '100%'}} value={tab}>
                        {menu.map((m, i) => (
                            <MenuItem key={m.k} value={m.k} onClick={() => {
                                s_app_mobile_tab.value = m.k;
                                setTab(m.k)
                            }}>{m.v}</MenuItem>
                        ))}
                        <MenuItem>
                            <Stack direction={'row'} justifyContent="flex-end" style={{width: '100%'}}>
                                <Button onClick={() => s_app_toggleMobile()}><ComputerIcon/></Button>
                                <Button onClick={() => logout()}>logout</Button>
                            </Stack>
                        </MenuItem>
                    </Select>
                </Paper>

            }
        </div>
    </Fragment>;
}

export default Main


/*
MenuProps={{
                            MenuListProps: {
                                sx: {minHeight: '100%', height: '100%'}
                            },
                            PaperProps: {
                                sx: {
                                    position: 'fixed',
                                    minHeight: '100% !important',
                                    maxHeight: '100% !important',
                                    height: '100%',
                                    top: '0 !important',
                                    left: '0 !important',
                                    right: '0 !important',
                                    bottom: '0 !important',
                                    margin: 0,
                                    padding: 0,
                                    minWidth: '100% !important',
                                    maxWidth: '100% !important',
                                    width: '100%',
                                },
                            },
                        }} */